
import * as util from 'util'

import * as big from '../big'
import * as int64 from '../int64'
import * as uuid from '../uuid'

import * as fbe from '../fbe'

const Big = big.Big // eslint-disable-line
const Int64 = int64.Int64 // eslint-disable-line
const UInt64 = int64.UInt64 // eslint-disable-line
const UUID = uuid.UUID // eslint-disable-line
import {FilterUint64} from './FilterUint64';
import {FieldModelFilterUint64} from './FilterUint64';
import {FilterString} from './FilterString';
import {FieldModelFilterString} from './FilterString';
import {FilterEnum} from './FilterEnum';
import {FieldModelFilterEnum} from './FilterEnum';
import {FilterDouble} from './FilterDouble';
import {FieldModelFilterDouble} from './FilterDouble';
import {FilterTime} from './FilterTime';
import {FieldModelFilterTime} from './FilterTime';
import {FilterInt32} from './FilterInt32';
import {FieldModelFilterInt32} from './FilterInt32';
import {FilterBool} from './FilterBool';
import {FieldModelFilterBool} from './FilterBool';
import {SocialTradingOrderInvestorFiltration} from './SocialTradingOrderInvestorFiltration';
import {FieldModelSocialTradingOrderInvestorFiltration} from './SocialTradingOrderInvestorFiltration';
import {SocialTradingOrderMasterFiltration} from './SocialTradingOrderMasterFiltration';
import {FieldModelSocialTradingOrderMasterFiltration} from './SocialTradingOrderMasterFiltration';
import {FilterUint32} from './FilterUint32';
import {FieldModelFilterUint32} from './FilterUint32';

/**
 * OrderFiltration struct
 */
class OrderFiltration {
  /**
   * Initialize struct
   * @param {FilterUint64=} login
   * @param {FilterUint64=} orderId
   * @param {FilterUint64=} parentOrderId
   * @param {FilterString=} clientOrderId
   * @param {FilterEnum=} orderSide
   * @param {FilterEnum=} orderType
   * @param {FilterEnum=} orderInitialType
   * @param {FilterEnum=} orderTimeInForce
   * @param {FilterEnum=} orderStatus
   * @param {FilterDouble=} price
   * @param {FilterDouble=} stopPrice
   * @param {FilterDouble=} takeProfit
   * @param {FilterDouble=} stopLoss
   * @param {FilterDouble=} amount
   * @param {FilterDouble=} executedAmount
   * @param {FilterDouble=} remainingAmount
   * @param {FilterTime=} expiration
   * @param {FilterString=} accountComment
   * @param {FilterString=} managerComment
   * @param {FilterInt32=} magic
   * @param {FilterTime=} created
   * @param {FilterTime=} modified
   * @param {FilterTime=} archived
   * @param {FilterTime=} deleted
   * @param {FilterDouble=} openPrice
   * @param {FilterDouble=} closePrice
   * @param {FilterDouble=} closeAmount
   * @param {FilterDouble=} openMarginRate
   * @param {FilterDouble=} commission
   * @param {FilterDouble=} swap
   * @param {FilterUint64=} openMarkup
   * @param {FilterDouble=} closeProfit
   * @param {FilterTime=} opened
   * @param {FilterTime=} closed
   * @param {FilterDouble=} openAccountMargin
   * @param {FilterDouble=} openAccountEquity
   * @param {FilterDouble=} openAccountCredit
   * @param {FilterDouble=} openAmount
   * @param {FilterEnum=} orderRequestSourceType
   * @param {FilterBool=} isCreatedViaQuickTrading
   * @param {FilterBool=} isCreatedViaFastTrader
   * @param {FilterEnum=} socialTradingOrderType
   * @param {SocialTradingOrderInvestorFiltration=} socialTradingOrderInvestor
   * @param {SocialTradingOrderMasterFiltration=} socialTradingOrderMaster
   * @param {FilterEnum=} socialTradingOrderInitialType
   * @param {SocialTradingOrderInvestorFiltration=} socialTradingOrderInitialInvestor
   * @param {SocialTradingOrderMasterFiltration=} socialTradingOrderInitialMaster
   * @param {FilterUint32=} trailingStopDistance
   * @param {FilterBool=} trailActive
   * @constructor
   */
  constructor (login = null, orderId = null, parentOrderId = null, clientOrderId = null, orderSide = null, orderType = null, orderInitialType = null, orderTimeInForce = null, orderStatus = null, price = null, stopPrice = null, takeProfit = null, stopLoss = null, amount = null, executedAmount = null, remainingAmount = null, expiration = null, accountComment = null, managerComment = null, magic = null, created = null, modified = null, archived = null, deleted = null, openPrice = null, closePrice = null, closeAmount = null, openMarginRate = null, commission = null, swap = null, openMarkup = null, closeProfit = null, opened = null, closed = null, openAccountMargin = null, openAccountEquity = null, openAccountCredit = null, openAmount = null, orderRequestSourceType = null, isCreatedViaQuickTrading = null, isCreatedViaFastTrader = null, socialTradingOrderType = null, socialTradingOrderInvestor = null, socialTradingOrderMaster = null, socialTradingOrderInitialType = null, socialTradingOrderInitialInvestor = null, socialTradingOrderInitialMaster = null, trailingStopDistance = null, trailActive = null) {
    this.Login = login
    this.OrderId = orderId
    this.ParentOrderId = parentOrderId
    this.ClientOrderId = clientOrderId
    this.OrderSide = orderSide
    this.OrderType = orderType
    this.OrderInitialType = orderInitialType
    this.OrderTimeInForce = orderTimeInForce
    this.OrderStatus = orderStatus
    this.Price = price
    this.StopPrice = stopPrice
    this.TakeProfit = takeProfit
    this.StopLoss = stopLoss
    this.Amount = amount
    this.ExecutedAmount = executedAmount
    this.RemainingAmount = remainingAmount
    this.Expiration = expiration
    this.AccountComment = accountComment
    this.ManagerComment = managerComment
    this.Magic = magic
    this.Created = created
    this.Modified = modified
    this.Archived = archived
    this.Deleted = deleted
    this.OpenPrice = openPrice
    this.ClosePrice = closePrice
    this.CloseAmount = closeAmount
    this.OpenMarginRate = openMarginRate
    this.Commission = commission
    this.Swap = swap
    this.OpenMarkup = openMarkup
    this.CloseProfit = closeProfit
    this.Opened = opened
    this.Closed = closed
    this.OpenAccountMargin = openAccountMargin
    this.OpenAccountEquity = openAccountEquity
    this.OpenAccountCredit = openAccountCredit
    this.OpenAmount = openAmount
    this.OrderRequestSourceType = orderRequestSourceType
    this.IsCreatedViaQuickTrading = isCreatedViaQuickTrading
    this.IsCreatedViaFastTrader = isCreatedViaFastTrader
    this.SocialTradingOrderType = socialTradingOrderType
    this.SocialTradingOrderInvestor = socialTradingOrderInvestor
    this.SocialTradingOrderMaster = socialTradingOrderMaster
    this.SocialTradingOrderInitialType = socialTradingOrderInitialType
    this.SocialTradingOrderInitialInvestor = socialTradingOrderInitialInvestor
    this.SocialTradingOrderInitialMaster = socialTradingOrderInitialMaster
    this.TrailingStopDistance = trailingStopDistance
    this.TrailActive = trailActive
  }

  /**
   * Copy struct (shallow copy)
   * @this {!OrderFiltration}
   * @param {!OrderFiltration} other Other struct
   * @returns {!OrderFiltration} This struct
   */
  copy (other) {
    if (other.Login != null) {
      this.Login = FilterUint64.fromObject(other.Login)
    } else {
      this.Login = null
    }
    if (other.OrderId != null) {
      this.OrderId = FilterUint64.fromObject(other.OrderId)
    } else {
      this.OrderId = null
    }
    if (other.ParentOrderId != null) {
      this.ParentOrderId = FilterUint64.fromObject(other.ParentOrderId)
    } else {
      this.ParentOrderId = null
    }
    if (other.ClientOrderId != null) {
      this.ClientOrderId = FilterString.fromObject(other.ClientOrderId)
    } else {
      this.ClientOrderId = null
    }
    if (other.OrderSide != null) {
      this.OrderSide = FilterEnum.fromObject(other.OrderSide)
    } else {
      this.OrderSide = null
    }
    if (other.OrderType != null) {
      this.OrderType = FilterEnum.fromObject(other.OrderType)
    } else {
      this.OrderType = null
    }
    if (other.OrderInitialType != null) {
      this.OrderInitialType = FilterEnum.fromObject(other.OrderInitialType)
    } else {
      this.OrderInitialType = null
    }
    if (other.OrderTimeInForce != null) {
      this.OrderTimeInForce = FilterEnum.fromObject(other.OrderTimeInForce)
    } else {
      this.OrderTimeInForce = null
    }
    if (other.OrderStatus != null) {
      this.OrderStatus = FilterEnum.fromObject(other.OrderStatus)
    } else {
      this.OrderStatus = null
    }
    if (other.Price != null) {
      this.Price = FilterDouble.fromObject(other.Price)
    } else {
      this.Price = null
    }
    if (other.StopPrice != null) {
      this.StopPrice = FilterDouble.fromObject(other.StopPrice)
    } else {
      this.StopPrice = null
    }
    if (other.TakeProfit != null) {
      this.TakeProfit = FilterDouble.fromObject(other.TakeProfit)
    } else {
      this.TakeProfit = null
    }
    if (other.StopLoss != null) {
      this.StopLoss = FilterDouble.fromObject(other.StopLoss)
    } else {
      this.StopLoss = null
    }
    if (other.Amount != null) {
      this.Amount = FilterDouble.fromObject(other.Amount)
    } else {
      this.Amount = null
    }
    if (other.ExecutedAmount != null) {
      this.ExecutedAmount = FilterDouble.fromObject(other.ExecutedAmount)
    } else {
      this.ExecutedAmount = null
    }
    if (other.RemainingAmount != null) {
      this.RemainingAmount = FilterDouble.fromObject(other.RemainingAmount)
    } else {
      this.RemainingAmount = null
    }
    if (other.Expiration != null) {
      this.Expiration = FilterTime.fromObject(other.Expiration)
    } else {
      this.Expiration = null
    }
    if (other.AccountComment != null) {
      this.AccountComment = FilterString.fromObject(other.AccountComment)
    } else {
      this.AccountComment = null
    }
    if (other.ManagerComment != null) {
      this.ManagerComment = FilterString.fromObject(other.ManagerComment)
    } else {
      this.ManagerComment = null
    }
    if (other.Magic != null) {
      this.Magic = FilterInt32.fromObject(other.Magic)
    } else {
      this.Magic = null
    }
    if (other.Created != null) {
      this.Created = FilterTime.fromObject(other.Created)
    } else {
      this.Created = null
    }
    if (other.Modified != null) {
      this.Modified = FilterTime.fromObject(other.Modified)
    } else {
      this.Modified = null
    }
    if (other.Archived != null) {
      this.Archived = FilterTime.fromObject(other.Archived)
    } else {
      this.Archived = null
    }
    if (other.Deleted != null) {
      this.Deleted = FilterTime.fromObject(other.Deleted)
    } else {
      this.Deleted = null
    }
    if (other.OpenPrice != null) {
      this.OpenPrice = FilterDouble.fromObject(other.OpenPrice)
    } else {
      this.OpenPrice = null
    }
    if (other.ClosePrice != null) {
      this.ClosePrice = FilterDouble.fromObject(other.ClosePrice)
    } else {
      this.ClosePrice = null
    }
    if (other.CloseAmount != null) {
      this.CloseAmount = FilterDouble.fromObject(other.CloseAmount)
    } else {
      this.CloseAmount = null
    }
    if (other.OpenMarginRate != null) {
      this.OpenMarginRate = FilterDouble.fromObject(other.OpenMarginRate)
    } else {
      this.OpenMarginRate = null
    }
    if (other.Commission != null) {
      this.Commission = FilterDouble.fromObject(other.Commission)
    } else {
      this.Commission = null
    }
    if (other.Swap != null) {
      this.Swap = FilterDouble.fromObject(other.Swap)
    } else {
      this.Swap = null
    }
    if (other.OpenMarkup != null) {
      this.OpenMarkup = FilterUint64.fromObject(other.OpenMarkup)
    } else {
      this.OpenMarkup = null
    }
    if (other.CloseProfit != null) {
      this.CloseProfit = FilterDouble.fromObject(other.CloseProfit)
    } else {
      this.CloseProfit = null
    }
    if (other.Opened != null) {
      this.Opened = FilterTime.fromObject(other.Opened)
    } else {
      this.Opened = null
    }
    if (other.Closed != null) {
      this.Closed = FilterTime.fromObject(other.Closed)
    } else {
      this.Closed = null
    }
    if (other.OpenAccountMargin != null) {
      this.OpenAccountMargin = FilterDouble.fromObject(other.OpenAccountMargin)
    } else {
      this.OpenAccountMargin = null
    }
    if (other.OpenAccountEquity != null) {
      this.OpenAccountEquity = FilterDouble.fromObject(other.OpenAccountEquity)
    } else {
      this.OpenAccountEquity = null
    }
    if (other.OpenAccountCredit != null) {
      this.OpenAccountCredit = FilterDouble.fromObject(other.OpenAccountCredit)
    } else {
      this.OpenAccountCredit = null
    }
    if (other.OpenAmount != null) {
      this.OpenAmount = FilterDouble.fromObject(other.OpenAmount)
    } else {
      this.OpenAmount = null
    }
    if (other.OrderRequestSourceType != null) {
      this.OrderRequestSourceType = FilterEnum.fromObject(other.OrderRequestSourceType)
    } else {
      this.OrderRequestSourceType = null
    }
    if (other.IsCreatedViaQuickTrading != null) {
      this.IsCreatedViaQuickTrading = FilterBool.fromObject(other.IsCreatedViaQuickTrading)
    } else {
      this.IsCreatedViaQuickTrading = null
    }
    if (other.IsCreatedViaFastTrader != null) {
      this.IsCreatedViaFastTrader = FilterBool.fromObject(other.IsCreatedViaFastTrader)
    } else {
      this.IsCreatedViaFastTrader = null
    }
    if (other.SocialTradingOrderType != null) {
      this.SocialTradingOrderType = FilterEnum.fromObject(other.SocialTradingOrderType)
    } else {
      this.SocialTradingOrderType = null
    }
    if (other.SocialTradingOrderInvestor != null) {
      this.SocialTradingOrderInvestor = SocialTradingOrderInvestorFiltration.fromObject(other.SocialTradingOrderInvestor)
    } else {
      this.SocialTradingOrderInvestor = null
    }
    if (other.SocialTradingOrderMaster != null) {
      this.SocialTradingOrderMaster = SocialTradingOrderMasterFiltration.fromObject(other.SocialTradingOrderMaster)
    } else {
      this.SocialTradingOrderMaster = null
    }
    if (other.SocialTradingOrderInitialType != null) {
      this.SocialTradingOrderInitialType = FilterEnum.fromObject(other.SocialTradingOrderInitialType)
    } else {
      this.SocialTradingOrderInitialType = null
    }
    if (other.SocialTradingOrderInitialInvestor != null) {
      this.SocialTradingOrderInitialInvestor = SocialTradingOrderInvestorFiltration.fromObject(other.SocialTradingOrderInitialInvestor)
    } else {
      this.SocialTradingOrderInitialInvestor = null
    }
    if (other.SocialTradingOrderInitialMaster != null) {
      this.SocialTradingOrderInitialMaster = SocialTradingOrderMasterFiltration.fromObject(other.SocialTradingOrderInitialMaster)
    } else {
      this.SocialTradingOrderInitialMaster = null
    }
    if (other.TrailingStopDistance != null) {
      this.TrailingStopDistance = FilterUint32.fromObject(other.TrailingStopDistance)
    } else {
      this.TrailingStopDistance = null
    }
    if (other.TrailActive != null) {
      this.TrailActive = FilterBool.fromObject(other.TrailActive)
    } else {
      this.TrailActive = null
    }
    return this
  }

  /**
   * Clone struct (deep clone)
   * @this {!OrderFiltration}
   * @returns {!OrderFiltration} Cloned struct
   */
  clone () {
    // Serialize the struct to the FBE stream
    let writer = new OrderFiltrationModel(new fbe.WriteBuffer())
    writer.serialize(this)

    // Deserialize the struct from the FBE stream
    let reader = new OrderFiltrationModel(new fbe.ReadBuffer())
    reader.attachBuffer(writer.buffer)
    return reader.deserialize().value
  }

  /**
   * Is this struct equal to other one?
   * @this {!OrderFiltration}
   * @param {!OrderFiltration} other Other struct
   * @returns {boolean} Equal result
   */
  eq (other) {
    if (!(other instanceof OrderFiltration)) {
      throw new TypeError('Instance of OrderFiltration is required!')
    }
    return true
  }

  /**
   * Convert struct to JSON
   * @this {!OrderFiltration}
   * @returns {!object} Struct value for JSON
   */
  toJSON () {
    return {
      Login: ((this.Login != null) ? this.Login : null),
      OrderId: ((this.OrderId != null) ? this.OrderId : null),
      ParentOrderId: ((this.ParentOrderId != null) ? this.ParentOrderId : null),
      ClientOrderId: ((this.ClientOrderId != null) ? this.ClientOrderId : null),
      OrderSide: ((this.OrderSide != null) ? this.OrderSide : null),
      OrderType: ((this.OrderType != null) ? this.OrderType : null),
      OrderInitialType: ((this.OrderInitialType != null) ? this.OrderInitialType : null),
      OrderTimeInForce: ((this.OrderTimeInForce != null) ? this.OrderTimeInForce : null),
      OrderStatus: ((this.OrderStatus != null) ? this.OrderStatus : null),
      Price: ((this.Price != null) ? this.Price : null),
      StopPrice: ((this.StopPrice != null) ? this.StopPrice : null),
      TakeProfit: ((this.TakeProfit != null) ? this.TakeProfit : null),
      StopLoss: ((this.StopLoss != null) ? this.StopLoss : null),
      Amount: ((this.Amount != null) ? this.Amount : null),
      ExecutedAmount: ((this.ExecutedAmount != null) ? this.ExecutedAmount : null),
      RemainingAmount: ((this.RemainingAmount != null) ? this.RemainingAmount : null),
      Expiration: ((this.Expiration != null) ? this.Expiration : null),
      AccountComment: ((this.AccountComment != null) ? this.AccountComment : null),
      ManagerComment: ((this.ManagerComment != null) ? this.ManagerComment : null),
      Magic: ((this.Magic != null) ? this.Magic : null),
      Created: ((this.Created != null) ? this.Created : null),
      Modified: ((this.Modified != null) ? this.Modified : null),
      Archived: ((this.Archived != null) ? this.Archived : null),
      Deleted: ((this.Deleted != null) ? this.Deleted : null),
      OpenPrice: ((this.OpenPrice != null) ? this.OpenPrice : null),
      ClosePrice: ((this.ClosePrice != null) ? this.ClosePrice : null),
      CloseAmount: ((this.CloseAmount != null) ? this.CloseAmount : null),
      OpenMarginRate: ((this.OpenMarginRate != null) ? this.OpenMarginRate : null),
      Commission: ((this.Commission != null) ? this.Commission : null),
      Swap: ((this.Swap != null) ? this.Swap : null),
      OpenMarkup: ((this.OpenMarkup != null) ? this.OpenMarkup : null),
      CloseProfit: ((this.CloseProfit != null) ? this.CloseProfit : null),
      Opened: ((this.Opened != null) ? this.Opened : null),
      Closed: ((this.Closed != null) ? this.Closed : null),
      OpenAccountMargin: ((this.OpenAccountMargin != null) ? this.OpenAccountMargin : null),
      OpenAccountEquity: ((this.OpenAccountEquity != null) ? this.OpenAccountEquity : null),
      OpenAccountCredit: ((this.OpenAccountCredit != null) ? this.OpenAccountCredit : null),
      OpenAmount: ((this.OpenAmount != null) ? this.OpenAmount : null),
      OrderRequestSourceType: ((this.OrderRequestSourceType != null) ? this.OrderRequestSourceType : null),
      IsCreatedViaQuickTrading: ((this.IsCreatedViaQuickTrading != null) ? this.IsCreatedViaQuickTrading : null),
      IsCreatedViaFastTrader: ((this.IsCreatedViaFastTrader != null) ? this.IsCreatedViaFastTrader : null),
      SocialTradingOrderType: ((this.SocialTradingOrderType != null) ? this.SocialTradingOrderType : null),
      SocialTradingOrderInvestor: ((this.SocialTradingOrderInvestor != null) ? this.SocialTradingOrderInvestor : null),
      SocialTradingOrderMaster: ((this.SocialTradingOrderMaster != null) ? this.SocialTradingOrderMaster : null),
      SocialTradingOrderInitialType: ((this.SocialTradingOrderInitialType != null) ? this.SocialTradingOrderInitialType : null),
      SocialTradingOrderInitialInvestor: ((this.SocialTradingOrderInitialInvestor != null) ? this.SocialTradingOrderInitialInvestor : null),
      SocialTradingOrderInitialMaster: ((this.SocialTradingOrderInitialMaster != null) ? this.SocialTradingOrderInitialMaster : null),
      TrailingStopDistance: ((this.TrailingStopDistance != null) ? this.TrailingStopDistance : null),
      TrailActive: ((this.TrailActive != null) ? this.TrailActive : null)
    }
  }

  /**
   * Convert JSON to struct
   * @param {!string} json JSON string
   * @returns {!object} Struct value for JSON
   */
  static fromJSON (json) {
    return OrderFiltration.fromObject(JSON.parse(json))
  }

  /**
   * Create struct from object value
   * @param {!OrderFiltration} other Object value
   * @returns {!OrderFiltration} Created struct
   */
  static fromObject (other) {
    return new OrderFiltration().copy(other)
  }

  /**
   * Get the FBE type
   * @this {!OrderFiltration}
   * @returns {!number} FBE type
   */
  get fbeType () {
    return OrderFiltration.fbeType
  }

  /**
   * Get the FBE type (static)
   * @this {!OrderFiltration}
   * @returns {!number} FBE type
   */
  static get fbeType () {
    return 131
  }
}

export { OrderFiltration };

/**
 * Fast Binary Encoding OrderFiltration field model
 */
class FieldModelOrderFiltration extends fbe.FieldModel {
  /**
   * Initialize field model with the given buffer and offset
   * @param {!fbe.ReadBuffer|!fbe.WriteBuffer} buffer Buffer
   * @param {!number} offset Offset
   * @constructor
   */
  constructor (buffer, offset) {
    super(buffer, offset)
    this.Login = new fbe.FieldModelOptional(new FieldModelFilterUint64(buffer, 4 + 4), buffer, 4 + 4)
    this.OrderId = new fbe.FieldModelOptional(new FieldModelFilterUint64(buffer, this.Login.fbeOffset + this.Login.fbeSize), buffer, this.Login.fbeOffset + this.Login.fbeSize)
    this.ParentOrderId = new fbe.FieldModelOptional(new FieldModelFilterUint64(buffer, this.OrderId.fbeOffset + this.OrderId.fbeSize), buffer, this.OrderId.fbeOffset + this.OrderId.fbeSize)
    this.ClientOrderId = new fbe.FieldModelOptional(new FieldModelFilterString(buffer, this.ParentOrderId.fbeOffset + this.ParentOrderId.fbeSize), buffer, this.ParentOrderId.fbeOffset + this.ParentOrderId.fbeSize)
    this.OrderSide = new fbe.FieldModelOptional(new FieldModelFilterEnum(buffer, this.ClientOrderId.fbeOffset + this.ClientOrderId.fbeSize), buffer, this.ClientOrderId.fbeOffset + this.ClientOrderId.fbeSize)
    this.OrderType = new fbe.FieldModelOptional(new FieldModelFilterEnum(buffer, this.OrderSide.fbeOffset + this.OrderSide.fbeSize), buffer, this.OrderSide.fbeOffset + this.OrderSide.fbeSize)
    this.OrderInitialType = new fbe.FieldModelOptional(new FieldModelFilterEnum(buffer, this.OrderType.fbeOffset + this.OrderType.fbeSize), buffer, this.OrderType.fbeOffset + this.OrderType.fbeSize)
    this.OrderTimeInForce = new fbe.FieldModelOptional(new FieldModelFilterEnum(buffer, this.OrderInitialType.fbeOffset + this.OrderInitialType.fbeSize), buffer, this.OrderInitialType.fbeOffset + this.OrderInitialType.fbeSize)
    this.OrderStatus = new fbe.FieldModelOptional(new FieldModelFilterEnum(buffer, this.OrderTimeInForce.fbeOffset + this.OrderTimeInForce.fbeSize), buffer, this.OrderTimeInForce.fbeOffset + this.OrderTimeInForce.fbeSize)
    this.Price = new fbe.FieldModelOptional(new FieldModelFilterDouble(buffer, this.OrderStatus.fbeOffset + this.OrderStatus.fbeSize), buffer, this.OrderStatus.fbeOffset + this.OrderStatus.fbeSize)
    this.StopPrice = new fbe.FieldModelOptional(new FieldModelFilterDouble(buffer, this.Price.fbeOffset + this.Price.fbeSize), buffer, this.Price.fbeOffset + this.Price.fbeSize)
    this.TakeProfit = new fbe.FieldModelOptional(new FieldModelFilterDouble(buffer, this.StopPrice.fbeOffset + this.StopPrice.fbeSize), buffer, this.StopPrice.fbeOffset + this.StopPrice.fbeSize)
    this.StopLoss = new fbe.FieldModelOptional(new FieldModelFilterDouble(buffer, this.TakeProfit.fbeOffset + this.TakeProfit.fbeSize), buffer, this.TakeProfit.fbeOffset + this.TakeProfit.fbeSize)
    this.Amount = new fbe.FieldModelOptional(new FieldModelFilterDouble(buffer, this.StopLoss.fbeOffset + this.StopLoss.fbeSize), buffer, this.StopLoss.fbeOffset + this.StopLoss.fbeSize)
    this.ExecutedAmount = new fbe.FieldModelOptional(new FieldModelFilterDouble(buffer, this.Amount.fbeOffset + this.Amount.fbeSize), buffer, this.Amount.fbeOffset + this.Amount.fbeSize)
    this.RemainingAmount = new fbe.FieldModelOptional(new FieldModelFilterDouble(buffer, this.ExecutedAmount.fbeOffset + this.ExecutedAmount.fbeSize), buffer, this.ExecutedAmount.fbeOffset + this.ExecutedAmount.fbeSize)
    this.Expiration = new fbe.FieldModelOptional(new FieldModelFilterTime(buffer, this.RemainingAmount.fbeOffset + this.RemainingAmount.fbeSize), buffer, this.RemainingAmount.fbeOffset + this.RemainingAmount.fbeSize)
    this.AccountComment = new fbe.FieldModelOptional(new FieldModelFilterString(buffer, this.Expiration.fbeOffset + this.Expiration.fbeSize), buffer, this.Expiration.fbeOffset + this.Expiration.fbeSize)
    this.ManagerComment = new fbe.FieldModelOptional(new FieldModelFilterString(buffer, this.AccountComment.fbeOffset + this.AccountComment.fbeSize), buffer, this.AccountComment.fbeOffset + this.AccountComment.fbeSize)
    this.Magic = new fbe.FieldModelOptional(new FieldModelFilterInt32(buffer, this.ManagerComment.fbeOffset + this.ManagerComment.fbeSize), buffer, this.ManagerComment.fbeOffset + this.ManagerComment.fbeSize)
    this.Created = new fbe.FieldModelOptional(new FieldModelFilterTime(buffer, this.Magic.fbeOffset + this.Magic.fbeSize), buffer, this.Magic.fbeOffset + this.Magic.fbeSize)
    this.Modified = new fbe.FieldModelOptional(new FieldModelFilterTime(buffer, this.Created.fbeOffset + this.Created.fbeSize), buffer, this.Created.fbeOffset + this.Created.fbeSize)
    this.Archived = new fbe.FieldModelOptional(new FieldModelFilterTime(buffer, this.Modified.fbeOffset + this.Modified.fbeSize), buffer, this.Modified.fbeOffset + this.Modified.fbeSize)
    this.Deleted = new fbe.FieldModelOptional(new FieldModelFilterTime(buffer, this.Archived.fbeOffset + this.Archived.fbeSize), buffer, this.Archived.fbeOffset + this.Archived.fbeSize)
    this.OpenPrice = new fbe.FieldModelOptional(new FieldModelFilterDouble(buffer, this.Deleted.fbeOffset + this.Deleted.fbeSize), buffer, this.Deleted.fbeOffset + this.Deleted.fbeSize)
    this.ClosePrice = new fbe.FieldModelOptional(new FieldModelFilterDouble(buffer, this.OpenPrice.fbeOffset + this.OpenPrice.fbeSize), buffer, this.OpenPrice.fbeOffset + this.OpenPrice.fbeSize)
    this.CloseAmount = new fbe.FieldModelOptional(new FieldModelFilterDouble(buffer, this.ClosePrice.fbeOffset + this.ClosePrice.fbeSize), buffer, this.ClosePrice.fbeOffset + this.ClosePrice.fbeSize)
    this.OpenMarginRate = new fbe.FieldModelOptional(new FieldModelFilterDouble(buffer, this.CloseAmount.fbeOffset + this.CloseAmount.fbeSize), buffer, this.CloseAmount.fbeOffset + this.CloseAmount.fbeSize)
    this.Commission = new fbe.FieldModelOptional(new FieldModelFilterDouble(buffer, this.OpenMarginRate.fbeOffset + this.OpenMarginRate.fbeSize), buffer, this.OpenMarginRate.fbeOffset + this.OpenMarginRate.fbeSize)
    this.Swap = new fbe.FieldModelOptional(new FieldModelFilterDouble(buffer, this.Commission.fbeOffset + this.Commission.fbeSize), buffer, this.Commission.fbeOffset + this.Commission.fbeSize)
    this.OpenMarkup = new fbe.FieldModelOptional(new FieldModelFilterUint64(buffer, this.Swap.fbeOffset + this.Swap.fbeSize), buffer, this.Swap.fbeOffset + this.Swap.fbeSize)
    this.CloseProfit = new fbe.FieldModelOptional(new FieldModelFilterDouble(buffer, this.OpenMarkup.fbeOffset + this.OpenMarkup.fbeSize), buffer, this.OpenMarkup.fbeOffset + this.OpenMarkup.fbeSize)
    this.Opened = new fbe.FieldModelOptional(new FieldModelFilterTime(buffer, this.CloseProfit.fbeOffset + this.CloseProfit.fbeSize), buffer, this.CloseProfit.fbeOffset + this.CloseProfit.fbeSize)
    this.Closed = new fbe.FieldModelOptional(new FieldModelFilterTime(buffer, this.Opened.fbeOffset + this.Opened.fbeSize), buffer, this.Opened.fbeOffset + this.Opened.fbeSize)
    this.OpenAccountMargin = new fbe.FieldModelOptional(new FieldModelFilterDouble(buffer, this.Closed.fbeOffset + this.Closed.fbeSize), buffer, this.Closed.fbeOffset + this.Closed.fbeSize)
    this.OpenAccountEquity = new fbe.FieldModelOptional(new FieldModelFilterDouble(buffer, this.OpenAccountMargin.fbeOffset + this.OpenAccountMargin.fbeSize), buffer, this.OpenAccountMargin.fbeOffset + this.OpenAccountMargin.fbeSize)
    this.OpenAccountCredit = new fbe.FieldModelOptional(new FieldModelFilterDouble(buffer, this.OpenAccountEquity.fbeOffset + this.OpenAccountEquity.fbeSize), buffer, this.OpenAccountEquity.fbeOffset + this.OpenAccountEquity.fbeSize)
    this.OpenAmount = new fbe.FieldModelOptional(new FieldModelFilterDouble(buffer, this.OpenAccountCredit.fbeOffset + this.OpenAccountCredit.fbeSize), buffer, this.OpenAccountCredit.fbeOffset + this.OpenAccountCredit.fbeSize)
    this.OrderRequestSourceType = new fbe.FieldModelOptional(new FieldModelFilterEnum(buffer, this.OpenAmount.fbeOffset + this.OpenAmount.fbeSize), buffer, this.OpenAmount.fbeOffset + this.OpenAmount.fbeSize)
    this.IsCreatedViaQuickTrading = new fbe.FieldModelOptional(new FieldModelFilterBool(buffer, this.OrderRequestSourceType.fbeOffset + this.OrderRequestSourceType.fbeSize), buffer, this.OrderRequestSourceType.fbeOffset + this.OrderRequestSourceType.fbeSize)
    this.IsCreatedViaFastTrader = new fbe.FieldModelOptional(new FieldModelFilterBool(buffer, this.IsCreatedViaQuickTrading.fbeOffset + this.IsCreatedViaQuickTrading.fbeSize), buffer, this.IsCreatedViaQuickTrading.fbeOffset + this.IsCreatedViaQuickTrading.fbeSize)
    this.SocialTradingOrderType = new fbe.FieldModelOptional(new FieldModelFilterEnum(buffer, this.IsCreatedViaFastTrader.fbeOffset + this.IsCreatedViaFastTrader.fbeSize), buffer, this.IsCreatedViaFastTrader.fbeOffset + this.IsCreatedViaFastTrader.fbeSize)
    this.SocialTradingOrderInvestor = new fbe.FieldModelOptional(new FieldModelSocialTradingOrderInvestorFiltration(buffer, this.SocialTradingOrderType.fbeOffset + this.SocialTradingOrderType.fbeSize), buffer, this.SocialTradingOrderType.fbeOffset + this.SocialTradingOrderType.fbeSize)
    this.SocialTradingOrderMaster = new fbe.FieldModelOptional(new FieldModelSocialTradingOrderMasterFiltration(buffer, this.SocialTradingOrderInvestor.fbeOffset + this.SocialTradingOrderInvestor.fbeSize), buffer, this.SocialTradingOrderInvestor.fbeOffset + this.SocialTradingOrderInvestor.fbeSize)
    this.SocialTradingOrderInitialType = new fbe.FieldModelOptional(new FieldModelFilterEnum(buffer, this.SocialTradingOrderMaster.fbeOffset + this.SocialTradingOrderMaster.fbeSize), buffer, this.SocialTradingOrderMaster.fbeOffset + this.SocialTradingOrderMaster.fbeSize)
    this.SocialTradingOrderInitialInvestor = new fbe.FieldModelOptional(new FieldModelSocialTradingOrderInvestorFiltration(buffer, this.SocialTradingOrderInitialType.fbeOffset + this.SocialTradingOrderInitialType.fbeSize), buffer, this.SocialTradingOrderInitialType.fbeOffset + this.SocialTradingOrderInitialType.fbeSize)
    this.SocialTradingOrderInitialMaster = new fbe.FieldModelOptional(new FieldModelSocialTradingOrderMasterFiltration(buffer, this.SocialTradingOrderInitialInvestor.fbeOffset + this.SocialTradingOrderInitialInvestor.fbeSize), buffer, this.SocialTradingOrderInitialInvestor.fbeOffset + this.SocialTradingOrderInitialInvestor.fbeSize)
    this.TrailingStopDistance = new fbe.FieldModelOptional(new FieldModelFilterUint32(buffer, this.SocialTradingOrderInitialMaster.fbeOffset + this.SocialTradingOrderInitialMaster.fbeSize), buffer, this.SocialTradingOrderInitialMaster.fbeOffset + this.SocialTradingOrderInitialMaster.fbeSize)
    this.TrailActive = new fbe.FieldModelOptional(new FieldModelFilterBool(buffer, this.TrailingStopDistance.fbeOffset + this.TrailingStopDistance.fbeSize), buffer, this.TrailingStopDistance.fbeOffset + this.TrailingStopDistance.fbeSize)
  }

  /**
   * Get the field size
   * @this {!FieldModelOrderFiltration}
   * @returns {!number} Field size
   */
  get fbeSize () {
    return 4
  }

  /**
   * Get the field body size
   * @this {!FieldModelOrderFiltration}
   * @returns {!number} Field body size
   */
  get fbeBody () {
    return 4 + 4 + this.Login.fbeSize + this.OrderId.fbeSize + this.ParentOrderId.fbeSize + this.ClientOrderId.fbeSize + this.OrderSide.fbeSize + this.OrderType.fbeSize + this.OrderInitialType.fbeSize + this.OrderTimeInForce.fbeSize + this.OrderStatus.fbeSize + this.Price.fbeSize + this.StopPrice.fbeSize + this.TakeProfit.fbeSize + this.StopLoss.fbeSize + this.Amount.fbeSize + this.ExecutedAmount.fbeSize + this.RemainingAmount.fbeSize + this.Expiration.fbeSize + this.AccountComment.fbeSize + this.ManagerComment.fbeSize + this.Magic.fbeSize + this.Created.fbeSize + this.Modified.fbeSize + this.Archived.fbeSize + this.Deleted.fbeSize + this.OpenPrice.fbeSize + this.ClosePrice.fbeSize + this.CloseAmount.fbeSize + this.OpenMarginRate.fbeSize + this.Commission.fbeSize + this.Swap.fbeSize + this.OpenMarkup.fbeSize + this.CloseProfit.fbeSize + this.Opened.fbeSize + this.Closed.fbeSize + this.OpenAccountMargin.fbeSize + this.OpenAccountEquity.fbeSize + this.OpenAccountCredit.fbeSize + this.OpenAmount.fbeSize + this.OrderRequestSourceType.fbeSize + this.IsCreatedViaQuickTrading.fbeSize + this.IsCreatedViaFastTrader.fbeSize + this.SocialTradingOrderType.fbeSize + this.SocialTradingOrderInvestor.fbeSize + this.SocialTradingOrderMaster.fbeSize + this.SocialTradingOrderInitialType.fbeSize + this.SocialTradingOrderInitialInvestor.fbeSize + this.SocialTradingOrderInitialMaster.fbeSize + this.TrailingStopDistance.fbeSize + this.TrailActive.fbeSize
  }

  /**
   * Get the field extra size
   * @this {!FieldModelOrderFiltration}
   * @returns {!number} Field extra size
   */
  get fbeExtra () {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4) > this._buffer.size)) {
      return 0
    }

    this._buffer.shift(fbeStructOffset)

    let fbeResult = this.fbeBody + this.Login.fbeExtra + this.OrderId.fbeExtra + this.ParentOrderId.fbeExtra + this.ClientOrderId.fbeExtra + this.OrderSide.fbeExtra + this.OrderType.fbeExtra + this.OrderInitialType.fbeExtra + this.OrderTimeInForce.fbeExtra + this.OrderStatus.fbeExtra + this.Price.fbeExtra + this.StopPrice.fbeExtra + this.TakeProfit.fbeExtra + this.StopLoss.fbeExtra + this.Amount.fbeExtra + this.ExecutedAmount.fbeExtra + this.RemainingAmount.fbeExtra + this.Expiration.fbeExtra + this.AccountComment.fbeExtra + this.ManagerComment.fbeExtra + this.Magic.fbeExtra + this.Created.fbeExtra + this.Modified.fbeExtra + this.Archived.fbeExtra + this.Deleted.fbeExtra + this.OpenPrice.fbeExtra + this.ClosePrice.fbeExtra + this.CloseAmount.fbeExtra + this.OpenMarginRate.fbeExtra + this.Commission.fbeExtra + this.Swap.fbeExtra + this.OpenMarkup.fbeExtra + this.CloseProfit.fbeExtra + this.Opened.fbeExtra + this.Closed.fbeExtra + this.OpenAccountMargin.fbeExtra + this.OpenAccountEquity.fbeExtra + this.OpenAccountCredit.fbeExtra + this.OpenAmount.fbeExtra + this.OrderRequestSourceType.fbeExtra + this.IsCreatedViaQuickTrading.fbeExtra + this.IsCreatedViaFastTrader.fbeExtra + this.SocialTradingOrderType.fbeExtra + this.SocialTradingOrderInvestor.fbeExtra + this.SocialTradingOrderMaster.fbeExtra + this.SocialTradingOrderInitialType.fbeExtra + this.SocialTradingOrderInitialInvestor.fbeExtra + this.SocialTradingOrderInitialMaster.fbeExtra + this.TrailingStopDistance.fbeExtra + this.TrailActive.fbeExtra

    this._buffer.unshift(fbeStructOffset)

    return fbeResult
  }

  /**
   * Get the field type
   * @this {!FieldModelOrderFiltration}
   * @returns {!number} Field type
   */
  get fbeType () {
    return FieldModelOrderFiltration.fbeType
  }

  /**
   * Get the field type (static)
   * @this {!FieldModelOrderFiltration}
   * @returns {!number} Field type
   */
  static get fbeType () {
    return 131
  }

  /**
   * Check if the struct value is valid
   * @this {!FieldModelOrderFiltration}
   * @param {!boolean} fbeVerifyType Verify model type flag, defaults is true
   * @returns {!boolean} Field model valid state
   */
  verify (fbeVerifyType = true) {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return true
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4 + 4) > this._buffer.size)) {
      return false
    }

    let fbeStructSize = this.readUInt32(fbeStructOffset)
    if (fbeStructSize < (4 + 4)) {
      return false
    }

    let fbeStructType = this.readUInt32(fbeStructOffset + 4)
    if (fbeVerifyType && (fbeStructType !== this.fbeType)) {
      return false
    }

    this._buffer.shift(fbeStructOffset)
    let fbeResult = this.verifyFields(fbeStructSize)
    this._buffer.unshift(fbeStructOffset)
    return fbeResult
  }

  /**
   * Check if the struct fields are valid
   * @this {!FieldModelOrderFiltration}
   * @param {!number} fbeStructSize FBE struct size
   * @returns {!boolean} Field model valid state
   */
  verifyFields (fbeStructSize) {
    let fbeCurrentSize = 4 + 4

    if ((fbeCurrentSize + this.Login.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.Login.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.Login.fbeSize

    if ((fbeCurrentSize + this.OrderId.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.OrderId.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.OrderId.fbeSize

    if ((fbeCurrentSize + this.ParentOrderId.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.ParentOrderId.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.ParentOrderId.fbeSize

    if ((fbeCurrentSize + this.ClientOrderId.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.ClientOrderId.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.ClientOrderId.fbeSize

    if ((fbeCurrentSize + this.OrderSide.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.OrderSide.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.OrderSide.fbeSize

    if ((fbeCurrentSize + this.OrderType.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.OrderType.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.OrderType.fbeSize

    if ((fbeCurrentSize + this.OrderInitialType.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.OrderInitialType.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.OrderInitialType.fbeSize

    if ((fbeCurrentSize + this.OrderTimeInForce.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.OrderTimeInForce.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.OrderTimeInForce.fbeSize

    if ((fbeCurrentSize + this.OrderStatus.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.OrderStatus.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.OrderStatus.fbeSize

    if ((fbeCurrentSize + this.Price.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.Price.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.Price.fbeSize

    if ((fbeCurrentSize + this.StopPrice.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.StopPrice.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.StopPrice.fbeSize

    if ((fbeCurrentSize + this.TakeProfit.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.TakeProfit.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.TakeProfit.fbeSize

    if ((fbeCurrentSize + this.StopLoss.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.StopLoss.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.StopLoss.fbeSize

    if ((fbeCurrentSize + this.Amount.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.Amount.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.Amount.fbeSize

    if ((fbeCurrentSize + this.ExecutedAmount.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.ExecutedAmount.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.ExecutedAmount.fbeSize

    if ((fbeCurrentSize + this.RemainingAmount.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.RemainingAmount.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.RemainingAmount.fbeSize

    if ((fbeCurrentSize + this.Expiration.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.Expiration.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.Expiration.fbeSize

    if ((fbeCurrentSize + this.AccountComment.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.AccountComment.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.AccountComment.fbeSize

    if ((fbeCurrentSize + this.ManagerComment.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.ManagerComment.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.ManagerComment.fbeSize

    if ((fbeCurrentSize + this.Magic.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.Magic.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.Magic.fbeSize

    if ((fbeCurrentSize + this.Created.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.Created.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.Created.fbeSize

    if ((fbeCurrentSize + this.Modified.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.Modified.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.Modified.fbeSize

    if ((fbeCurrentSize + this.Archived.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.Archived.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.Archived.fbeSize

    if ((fbeCurrentSize + this.Deleted.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.Deleted.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.Deleted.fbeSize

    if ((fbeCurrentSize + this.OpenPrice.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.OpenPrice.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.OpenPrice.fbeSize

    if ((fbeCurrentSize + this.ClosePrice.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.ClosePrice.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.ClosePrice.fbeSize

    if ((fbeCurrentSize + this.CloseAmount.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.CloseAmount.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.CloseAmount.fbeSize

    if ((fbeCurrentSize + this.OpenMarginRate.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.OpenMarginRate.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.OpenMarginRate.fbeSize

    if ((fbeCurrentSize + this.Commission.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.Commission.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.Commission.fbeSize

    if ((fbeCurrentSize + this.Swap.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.Swap.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.Swap.fbeSize

    if ((fbeCurrentSize + this.OpenMarkup.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.OpenMarkup.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.OpenMarkup.fbeSize

    if ((fbeCurrentSize + this.CloseProfit.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.CloseProfit.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.CloseProfit.fbeSize

    if ((fbeCurrentSize + this.Opened.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.Opened.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.Opened.fbeSize

    if ((fbeCurrentSize + this.Closed.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.Closed.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.Closed.fbeSize

    if ((fbeCurrentSize + this.OpenAccountMargin.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.OpenAccountMargin.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.OpenAccountMargin.fbeSize

    if ((fbeCurrentSize + this.OpenAccountEquity.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.OpenAccountEquity.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.OpenAccountEquity.fbeSize

    if ((fbeCurrentSize + this.OpenAccountCredit.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.OpenAccountCredit.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.OpenAccountCredit.fbeSize

    if ((fbeCurrentSize + this.OpenAmount.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.OpenAmount.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.OpenAmount.fbeSize

    if ((fbeCurrentSize + this.OrderRequestSourceType.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.OrderRequestSourceType.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.OrderRequestSourceType.fbeSize

    if ((fbeCurrentSize + this.IsCreatedViaQuickTrading.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.IsCreatedViaQuickTrading.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.IsCreatedViaQuickTrading.fbeSize

    if ((fbeCurrentSize + this.IsCreatedViaFastTrader.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.IsCreatedViaFastTrader.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.IsCreatedViaFastTrader.fbeSize

    if ((fbeCurrentSize + this.SocialTradingOrderType.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.SocialTradingOrderType.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.SocialTradingOrderType.fbeSize

    if ((fbeCurrentSize + this.SocialTradingOrderInvestor.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.SocialTradingOrderInvestor.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.SocialTradingOrderInvestor.fbeSize

    if ((fbeCurrentSize + this.SocialTradingOrderMaster.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.SocialTradingOrderMaster.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.SocialTradingOrderMaster.fbeSize

    if ((fbeCurrentSize + this.SocialTradingOrderInitialType.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.SocialTradingOrderInitialType.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.SocialTradingOrderInitialType.fbeSize

    if ((fbeCurrentSize + this.SocialTradingOrderInitialInvestor.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.SocialTradingOrderInitialInvestor.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.SocialTradingOrderInitialInvestor.fbeSize

    if ((fbeCurrentSize + this.SocialTradingOrderInitialMaster.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.SocialTradingOrderInitialMaster.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.SocialTradingOrderInitialMaster.fbeSize

    if ((fbeCurrentSize + this.TrailingStopDistance.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.TrailingStopDistance.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.TrailingStopDistance.fbeSize

    if ((fbeCurrentSize + this.TrailActive.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.TrailActive.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.TrailActive.fbeSize

    return true
  }

  /**
   * Get the struct value (begin phase)
   * @this {!FieldModelOrderFiltration}
   * @returns {!number} Field model begin offset
   */
  getBegin () {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    console.assert((fbeStructOffset > 0) && ((this._buffer.offset + fbeStructOffset + 4 + 4) <= this._buffer.size), 'Model is broken!')
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4 + 4) > this._buffer.size)) {
      return 0
    }

    let fbeStructSize = this.readUInt32(fbeStructOffset)
    console.assert((fbeStructSize >= (4 + 4)), 'Model is broken!')
    if (fbeStructSize < (4 + 4)) {
      return 0
    }

    this._buffer.shift(fbeStructOffset)
    return fbeStructOffset
  }

  /**
   * Get the struct value (end phase)
   * @this {!FieldModelOrderFiltration}
   * @param {!number} fbeBegin Field model begin offset
   */
  getEnd (fbeBegin) {
    this._buffer.unshift(fbeBegin)
  }

  /**
   * Get the struct value
   * @this {!FieldModelOrderFiltration}
   * @param {!OrderFiltration} fbeValue Default value, defaults is new OrderFiltration()
   * @returns {!OrderFiltration} OrderFiltration value
   */
  get (fbeValue = new OrderFiltration()) {
    let fbeBegin = this.getBegin()
    if (fbeBegin === 0) {
      return fbeValue
    }

    let fbeStructSize = this.readUInt32(0)
    this.getFields(fbeValue, fbeStructSize)
    this.getEnd(fbeBegin)
    return fbeValue
  }

  /**
   * Get the struct fields values
   * @this {!FieldModelOrderFiltration}
   * @param {!OrderFiltration} fbeValue OrderFiltration value
   * @param {!number} fbeStructSize Struct size
   */
  getFields (fbeValue, fbeStructSize) {
    let fbeCurrentSize = 4 + 4

    if ((fbeCurrentSize + this.Login.fbeSize) <= fbeStructSize) {
      fbeValue.Login = this.Login.get()
    } else {
      fbeValue.Login = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.Login.fbeSize

    if ((fbeCurrentSize + this.OrderId.fbeSize) <= fbeStructSize) {
      fbeValue.OrderId = this.OrderId.get()
    } else {
      fbeValue.OrderId = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.OrderId.fbeSize

    if ((fbeCurrentSize + this.ParentOrderId.fbeSize) <= fbeStructSize) {
      fbeValue.ParentOrderId = this.ParentOrderId.get()
    } else {
      fbeValue.ParentOrderId = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.ParentOrderId.fbeSize

    if ((fbeCurrentSize + this.ClientOrderId.fbeSize) <= fbeStructSize) {
      fbeValue.ClientOrderId = this.ClientOrderId.get()
    } else {
      fbeValue.ClientOrderId = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.ClientOrderId.fbeSize

    if ((fbeCurrentSize + this.OrderSide.fbeSize) <= fbeStructSize) {
      fbeValue.OrderSide = this.OrderSide.get()
    } else {
      fbeValue.OrderSide = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.OrderSide.fbeSize

    if ((fbeCurrentSize + this.OrderType.fbeSize) <= fbeStructSize) {
      fbeValue.OrderType = this.OrderType.get()
    } else {
      fbeValue.OrderType = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.OrderType.fbeSize

    if ((fbeCurrentSize + this.OrderInitialType.fbeSize) <= fbeStructSize) {
      fbeValue.OrderInitialType = this.OrderInitialType.get()
    } else {
      fbeValue.OrderInitialType = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.OrderInitialType.fbeSize

    if ((fbeCurrentSize + this.OrderTimeInForce.fbeSize) <= fbeStructSize) {
      fbeValue.OrderTimeInForce = this.OrderTimeInForce.get()
    } else {
      fbeValue.OrderTimeInForce = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.OrderTimeInForce.fbeSize

    if ((fbeCurrentSize + this.OrderStatus.fbeSize) <= fbeStructSize) {
      fbeValue.OrderStatus = this.OrderStatus.get()
    } else {
      fbeValue.OrderStatus = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.OrderStatus.fbeSize

    if ((fbeCurrentSize + this.Price.fbeSize) <= fbeStructSize) {
      fbeValue.Price = this.Price.get()
    } else {
      fbeValue.Price = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.Price.fbeSize

    if ((fbeCurrentSize + this.StopPrice.fbeSize) <= fbeStructSize) {
      fbeValue.StopPrice = this.StopPrice.get()
    } else {
      fbeValue.StopPrice = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.StopPrice.fbeSize

    if ((fbeCurrentSize + this.TakeProfit.fbeSize) <= fbeStructSize) {
      fbeValue.TakeProfit = this.TakeProfit.get()
    } else {
      fbeValue.TakeProfit = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.TakeProfit.fbeSize

    if ((fbeCurrentSize + this.StopLoss.fbeSize) <= fbeStructSize) {
      fbeValue.StopLoss = this.StopLoss.get()
    } else {
      fbeValue.StopLoss = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.StopLoss.fbeSize

    if ((fbeCurrentSize + this.Amount.fbeSize) <= fbeStructSize) {
      fbeValue.Amount = this.Amount.get()
    } else {
      fbeValue.Amount = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.Amount.fbeSize

    if ((fbeCurrentSize + this.ExecutedAmount.fbeSize) <= fbeStructSize) {
      fbeValue.ExecutedAmount = this.ExecutedAmount.get()
    } else {
      fbeValue.ExecutedAmount = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.ExecutedAmount.fbeSize

    if ((fbeCurrentSize + this.RemainingAmount.fbeSize) <= fbeStructSize) {
      fbeValue.RemainingAmount = this.RemainingAmount.get()
    } else {
      fbeValue.RemainingAmount = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.RemainingAmount.fbeSize

    if ((fbeCurrentSize + this.Expiration.fbeSize) <= fbeStructSize) {
      fbeValue.Expiration = this.Expiration.get()
    } else {
      fbeValue.Expiration = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.Expiration.fbeSize

    if ((fbeCurrentSize + this.AccountComment.fbeSize) <= fbeStructSize) {
      fbeValue.AccountComment = this.AccountComment.get()
    } else {
      fbeValue.AccountComment = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.AccountComment.fbeSize

    if ((fbeCurrentSize + this.ManagerComment.fbeSize) <= fbeStructSize) {
      fbeValue.ManagerComment = this.ManagerComment.get()
    } else {
      fbeValue.ManagerComment = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.ManagerComment.fbeSize

    if ((fbeCurrentSize + this.Magic.fbeSize) <= fbeStructSize) {
      fbeValue.Magic = this.Magic.get()
    } else {
      fbeValue.Magic = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.Magic.fbeSize

    if ((fbeCurrentSize + this.Created.fbeSize) <= fbeStructSize) {
      fbeValue.Created = this.Created.get()
    } else {
      fbeValue.Created = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.Created.fbeSize

    if ((fbeCurrentSize + this.Modified.fbeSize) <= fbeStructSize) {
      fbeValue.Modified = this.Modified.get()
    } else {
      fbeValue.Modified = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.Modified.fbeSize

    if ((fbeCurrentSize + this.Archived.fbeSize) <= fbeStructSize) {
      fbeValue.Archived = this.Archived.get()
    } else {
      fbeValue.Archived = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.Archived.fbeSize

    if ((fbeCurrentSize + this.Deleted.fbeSize) <= fbeStructSize) {
      fbeValue.Deleted = this.Deleted.get()
    } else {
      fbeValue.Deleted = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.Deleted.fbeSize

    if ((fbeCurrentSize + this.OpenPrice.fbeSize) <= fbeStructSize) {
      fbeValue.OpenPrice = this.OpenPrice.get()
    } else {
      fbeValue.OpenPrice = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.OpenPrice.fbeSize

    if ((fbeCurrentSize + this.ClosePrice.fbeSize) <= fbeStructSize) {
      fbeValue.ClosePrice = this.ClosePrice.get()
    } else {
      fbeValue.ClosePrice = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.ClosePrice.fbeSize

    if ((fbeCurrentSize + this.CloseAmount.fbeSize) <= fbeStructSize) {
      fbeValue.CloseAmount = this.CloseAmount.get()
    } else {
      fbeValue.CloseAmount = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.CloseAmount.fbeSize

    if ((fbeCurrentSize + this.OpenMarginRate.fbeSize) <= fbeStructSize) {
      fbeValue.OpenMarginRate = this.OpenMarginRate.get()
    } else {
      fbeValue.OpenMarginRate = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.OpenMarginRate.fbeSize

    if ((fbeCurrentSize + this.Commission.fbeSize) <= fbeStructSize) {
      fbeValue.Commission = this.Commission.get()
    } else {
      fbeValue.Commission = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.Commission.fbeSize

    if ((fbeCurrentSize + this.Swap.fbeSize) <= fbeStructSize) {
      fbeValue.Swap = this.Swap.get()
    } else {
      fbeValue.Swap = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.Swap.fbeSize

    if ((fbeCurrentSize + this.OpenMarkup.fbeSize) <= fbeStructSize) {
      fbeValue.OpenMarkup = this.OpenMarkup.get()
    } else {
      fbeValue.OpenMarkup = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.OpenMarkup.fbeSize

    if ((fbeCurrentSize + this.CloseProfit.fbeSize) <= fbeStructSize) {
      fbeValue.CloseProfit = this.CloseProfit.get()
    } else {
      fbeValue.CloseProfit = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.CloseProfit.fbeSize

    if ((fbeCurrentSize + this.Opened.fbeSize) <= fbeStructSize) {
      fbeValue.Opened = this.Opened.get()
    } else {
      fbeValue.Opened = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.Opened.fbeSize

    if ((fbeCurrentSize + this.Closed.fbeSize) <= fbeStructSize) {
      fbeValue.Closed = this.Closed.get()
    } else {
      fbeValue.Closed = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.Closed.fbeSize

    if ((fbeCurrentSize + this.OpenAccountMargin.fbeSize) <= fbeStructSize) {
      fbeValue.OpenAccountMargin = this.OpenAccountMargin.get()
    } else {
      fbeValue.OpenAccountMargin = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.OpenAccountMargin.fbeSize

    if ((fbeCurrentSize + this.OpenAccountEquity.fbeSize) <= fbeStructSize) {
      fbeValue.OpenAccountEquity = this.OpenAccountEquity.get()
    } else {
      fbeValue.OpenAccountEquity = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.OpenAccountEquity.fbeSize

    if ((fbeCurrentSize + this.OpenAccountCredit.fbeSize) <= fbeStructSize) {
      fbeValue.OpenAccountCredit = this.OpenAccountCredit.get()
    } else {
      fbeValue.OpenAccountCredit = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.OpenAccountCredit.fbeSize

    if ((fbeCurrentSize + this.OpenAmount.fbeSize) <= fbeStructSize) {
      fbeValue.OpenAmount = this.OpenAmount.get()
    } else {
      fbeValue.OpenAmount = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.OpenAmount.fbeSize

    if ((fbeCurrentSize + this.OrderRequestSourceType.fbeSize) <= fbeStructSize) {
      fbeValue.OrderRequestSourceType = this.OrderRequestSourceType.get()
    } else {
      fbeValue.OrderRequestSourceType = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.OrderRequestSourceType.fbeSize

    if ((fbeCurrentSize + this.IsCreatedViaQuickTrading.fbeSize) <= fbeStructSize) {
      fbeValue.IsCreatedViaQuickTrading = this.IsCreatedViaQuickTrading.get()
    } else {
      fbeValue.IsCreatedViaQuickTrading = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.IsCreatedViaQuickTrading.fbeSize

    if ((fbeCurrentSize + this.IsCreatedViaFastTrader.fbeSize) <= fbeStructSize) {
      fbeValue.IsCreatedViaFastTrader = this.IsCreatedViaFastTrader.get()
    } else {
      fbeValue.IsCreatedViaFastTrader = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.IsCreatedViaFastTrader.fbeSize

    if ((fbeCurrentSize + this.SocialTradingOrderType.fbeSize) <= fbeStructSize) {
      fbeValue.SocialTradingOrderType = this.SocialTradingOrderType.get()
    } else {
      fbeValue.SocialTradingOrderType = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.SocialTradingOrderType.fbeSize

    if ((fbeCurrentSize + this.SocialTradingOrderInvestor.fbeSize) <= fbeStructSize) {
      fbeValue.SocialTradingOrderInvestor = this.SocialTradingOrderInvestor.get()
    } else {
      fbeValue.SocialTradingOrderInvestor = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.SocialTradingOrderInvestor.fbeSize

    if ((fbeCurrentSize + this.SocialTradingOrderMaster.fbeSize) <= fbeStructSize) {
      fbeValue.SocialTradingOrderMaster = this.SocialTradingOrderMaster.get()
    } else {
      fbeValue.SocialTradingOrderMaster = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.SocialTradingOrderMaster.fbeSize

    if ((fbeCurrentSize + this.SocialTradingOrderInitialType.fbeSize) <= fbeStructSize) {
      fbeValue.SocialTradingOrderInitialType = this.SocialTradingOrderInitialType.get()
    } else {
      fbeValue.SocialTradingOrderInitialType = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.SocialTradingOrderInitialType.fbeSize

    if ((fbeCurrentSize + this.SocialTradingOrderInitialInvestor.fbeSize) <= fbeStructSize) {
      fbeValue.SocialTradingOrderInitialInvestor = this.SocialTradingOrderInitialInvestor.get()
    } else {
      fbeValue.SocialTradingOrderInitialInvestor = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.SocialTradingOrderInitialInvestor.fbeSize

    if ((fbeCurrentSize + this.SocialTradingOrderInitialMaster.fbeSize) <= fbeStructSize) {
      fbeValue.SocialTradingOrderInitialMaster = this.SocialTradingOrderInitialMaster.get()
    } else {
      fbeValue.SocialTradingOrderInitialMaster = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.SocialTradingOrderInitialMaster.fbeSize

    if ((fbeCurrentSize + this.TrailingStopDistance.fbeSize) <= fbeStructSize) {
      fbeValue.TrailingStopDistance = this.TrailingStopDistance.get()
    } else {
      fbeValue.TrailingStopDistance = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.TrailingStopDistance.fbeSize

    if ((fbeCurrentSize + this.TrailActive.fbeSize) <= fbeStructSize) {
      fbeValue.TrailActive = this.TrailActive.get()
    } else {
      fbeValue.TrailActive = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.TrailActive.fbeSize
  }

  /**
   * Set the struct value (begin phase)
   * @this {!FieldModelOrderFiltration}
   * @returns {!number} Field model begin offset
   */
  setBegin () {
    console.assert(((this._buffer.offset + this.fbeOffset + this.fbeSize) <= this._buffer.size), 'Model is broken!')
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructSize = this.fbeBody
    let fbeStructOffset = this._buffer.allocate(fbeStructSize) - this._buffer.offset
    console.assert((fbeStructOffset > 0) && ((this._buffer.offset + fbeStructOffset + fbeStructSize) <= this._buffer.size), 'Model is broken!')
    if ((fbeStructOffset <= 0) || ((this._buffer.offset + fbeStructOffset + fbeStructSize) > this._buffer.size)) {
      return 0
    }

    this.writeUInt32(this.fbeOffset, fbeStructOffset)
    this.writeUInt32(fbeStructOffset, fbeStructSize)
    this.writeUInt32(fbeStructOffset + 4, this.fbeType)

    this._buffer.shift(fbeStructOffset)
    return fbeStructOffset
  }

  /**
   * Set the struct value (end phase)
   * @this {!FieldModelOrderFiltration}
   * @param {!number} fbeBegin Field model begin offset
   */
  setEnd (fbeBegin) {
    this._buffer.unshift(fbeBegin)
  }

  /**
   * Set the struct value
   * @this {!FieldModelOrderFiltration}
   * @param {!OrderFiltration} fbeValue OrderFiltration value
   */
  set (fbeValue) {
    let fbeBegin = this.setBegin()
    if (fbeBegin === 0) {
      return
    }

    this.setFields(fbeValue)
    this.setEnd(fbeBegin)
  }

  /**
   * Set the struct fields values
   * @this {!FieldModelOrderFiltration}
   * @param {OrderFiltration} fbeValue OrderFiltration value
   */
  setFields (fbeValue) {
    this.Login.set(fbeValue.Login)
    this.OrderId.set(fbeValue.OrderId)
    this.ParentOrderId.set(fbeValue.ParentOrderId)
    this.ClientOrderId.set(fbeValue.ClientOrderId)
    this.OrderSide.set(fbeValue.OrderSide)
    this.OrderType.set(fbeValue.OrderType)
    this.OrderInitialType.set(fbeValue.OrderInitialType)
    this.OrderTimeInForce.set(fbeValue.OrderTimeInForce)
    this.OrderStatus.set(fbeValue.OrderStatus)
    this.Price.set(fbeValue.Price)
    this.StopPrice.set(fbeValue.StopPrice)
    this.TakeProfit.set(fbeValue.TakeProfit)
    this.StopLoss.set(fbeValue.StopLoss)
    this.Amount.set(fbeValue.Amount)
    this.ExecutedAmount.set(fbeValue.ExecutedAmount)
    this.RemainingAmount.set(fbeValue.RemainingAmount)
    this.Expiration.set(fbeValue.Expiration)
    this.AccountComment.set(fbeValue.AccountComment)
    this.ManagerComment.set(fbeValue.ManagerComment)
    this.Magic.set(fbeValue.Magic)
    this.Created.set(fbeValue.Created)
    this.Modified.set(fbeValue.Modified)
    this.Archived.set(fbeValue.Archived)
    this.Deleted.set(fbeValue.Deleted)
    this.OpenPrice.set(fbeValue.OpenPrice)
    this.ClosePrice.set(fbeValue.ClosePrice)
    this.CloseAmount.set(fbeValue.CloseAmount)
    this.OpenMarginRate.set(fbeValue.OpenMarginRate)
    this.Commission.set(fbeValue.Commission)
    this.Swap.set(fbeValue.Swap)
    this.OpenMarkup.set(fbeValue.OpenMarkup)
    this.CloseProfit.set(fbeValue.CloseProfit)
    this.Opened.set(fbeValue.Opened)
    this.Closed.set(fbeValue.Closed)
    this.OpenAccountMargin.set(fbeValue.OpenAccountMargin)
    this.OpenAccountEquity.set(fbeValue.OpenAccountEquity)
    this.OpenAccountCredit.set(fbeValue.OpenAccountCredit)
    this.OpenAmount.set(fbeValue.OpenAmount)
    this.OrderRequestSourceType.set(fbeValue.OrderRequestSourceType)
    this.IsCreatedViaQuickTrading.set(fbeValue.IsCreatedViaQuickTrading)
    this.IsCreatedViaFastTrader.set(fbeValue.IsCreatedViaFastTrader)
    this.SocialTradingOrderType.set(fbeValue.SocialTradingOrderType)
    this.SocialTradingOrderInvestor.set(fbeValue.SocialTradingOrderInvestor)
    this.SocialTradingOrderMaster.set(fbeValue.SocialTradingOrderMaster)
    this.SocialTradingOrderInitialType.set(fbeValue.SocialTradingOrderInitialType)
    this.SocialTradingOrderInitialInvestor.set(fbeValue.SocialTradingOrderInitialInvestor)
    this.SocialTradingOrderInitialMaster.set(fbeValue.SocialTradingOrderInitialMaster)
    this.TrailingStopDistance.set(fbeValue.TrailingStopDistance)
    this.TrailActive.set(fbeValue.TrailActive)
  }
}

export { FieldModelOrderFiltration };

/**
 * Fast Binary Encoding OrderFiltration model
 */
class OrderFiltrationModel extends fbe.Model {
  /**
   * Initialize model with the given buffer
   * @param {!fbe.ReadBuffer|!fbe.WriteBuffer} buffer Read/Write buffer, defaults is new fbe.WriteBuffer()
   * @constructor
   */
  constructor (buffer = new fbe.WriteBuffer()) {
    super(buffer)
    this._model = new FieldModelOrderFiltration(this.buffer, 4)
  }

  /**
   * Get the OrderFiltration model
   * @this {!OrderFiltrationModel}
   * @returns {!FieldModelOrderFiltration} model OrderFiltration model
   */
  get model () {
    return this._model
  }

  /**
   * Get the model size
   * @this {!OrderFiltrationModel}
   * @returns {!number} Model size
   */
  get fbeSize () {
    return this.model.fbeSize + this.model.fbeExtra
  }

  /**
   * Get the model type
   * @this {!OrderFiltrationModel}
   * @returns {!number} Model type
   */
  get fbeType () {
    return OrderFiltrationModel.fbeType
  }

  /**
   * Get the model type (static)
   * @this {!OrderFiltrationModel}
   * @returns {!number} Model type
   */
  static get fbeType () {
    return FieldModelOrderFiltration.fbeType
  }

  /**
   * Check if the struct value is valid
   * @this {!OrderFiltrationModel}
   * @returns {!boolean} Model valid state
   */
  verify () {
    if ((this.buffer.offset + this.model.fbeOffset - 4) > this.buffer.size) {
      return false
    }

    let fbeFullSize = this.readUInt32(this.model.fbeOffset - 4)
    if (fbeFullSize < this.model.fbeSize) {
      return false
    }

    return this.model.verify()
  }

  /**
   * Create a new model (begin phase)
   * @this {!OrderFiltrationModel}
   * @returns {!number} Model begin offset
   */
  createBegin () {
    return this.buffer.allocate(4 + this.model.fbeSize)
  }

  /**
   * Create a new model (end phase)
   * @this {!OrderFiltrationModel}
   * @param {!number} fbeBegin Model begin offset
   */
  createEnd (fbeBegin) {
    let fbeEnd = this.buffer.size
    let fbeFullSize = fbeEnd - fbeBegin
    this.writeUInt32(this.model.fbeOffset - 4, fbeFullSize)
    return fbeFullSize
  }

  /**
   * Serialize the struct value
   * @this {!OrderFiltrationModel}
   * @param {!OrderFiltration} value OrderFiltration value
   * @return {!number} Model begin offset
   */
  serialize (value) {
    let fbeBegin = this.createBegin()
    this.model.set(value)
    return this.createEnd(fbeBegin)
  }

  /**
   * Deserialize the struct value
   * @this {!OrderFiltrationModel}
   * @param {!OrderFiltration} value OrderFiltration value, defaults is new OrderFiltration()
   * @return {!object} Deserialized OrderFiltration value and its size
   */
  deserialize (value = new OrderFiltration()) {
    if ((this.buffer.offset + this.model.fbeOffset - 4) > this.buffer.size) {
      return { value: new OrderFiltration(), size: 0 }
    }

    let fbeFullSize = this.readUInt32(this.model.fbeOffset - 4)
    console.assert((fbeFullSize >= this.model.fbeSize), 'Model is broken!')
    if (fbeFullSize < this.model.fbeSize) {
      return { value: new OrderFiltration(), size: 0 }
    }

    this.model.get(value)
    return { value: value, size: fbeFullSize }
  }

  /**
   * Move to the next struct value
   * @this {!OrderFiltrationModel}
   * @param {!number} prev Previous OrderFiltration model size
   */
  next (prev) {
    this.model.fbeShift(prev)
  }
}

export { OrderFiltrationModel };
